import { css, FlattenSimpleInterpolation } from 'styled-components';

export const highContrast = (innerCss: FlattenSimpleInterpolation) => css`
  @media (forced-colors: active) {
    ${innerCss};
  }
`;
